import { initSentry } from "@dreebit-registry/vsm-microservice-components";

// This app owns the root path, so /crm and /catalog are served from the same origin
// by *other* microservices: skip init on their routes, drop their events and
// breadcrumbs, and keep trace propagation off them. Local dev is not reported.
initSentry({
    dsn: "https://183c29e19eca423ab5e3cc065fce4f95@bugsink.dreebit.com/3",
    skipOnLocal: true,
    excludePaths: ["/crm", "/catalog"],
    prefixIssuesWithEnvironment: true,
});
